<div class="m-subheader" style="position: relative;">
  <div class="d-flex align-items-center" style="flex-wrap: wrap;">
    <div class="mr-auto">
      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li class="m-nav__item m-nav__item--home">
          <a routerLink="/" class="m-nav__link m-nav__link--icon">
            <i class="m-nav__link-icon la la-home"></i>
          </a>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <a routerLink="../" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'spend-update.allExpenses' | transloco }}
            </span>
          </a>
        </li>
        <li class="m-nav__item">
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--head-solid-bg">
        <div class="m-portlet__head" style="position: relative;">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{ 'spend-update.changeFlow' | transloco }}
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div  class="row">
            <div class="col-md-12">
              <form class="m-form m-form--state" [formGroup]="form" (ngSubmit)="onSubmitForm()">
                <div class="m-form__section">
                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'spend-update.shop' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-store-select formControlName="storeId"></hx-store-select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'spend-update.number' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <input type="text" formControlName="incomingNumber" class="form-control m-input" placeholder="">
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'spend-update.category' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <app-spend-category-search [code]="form.controls.spendCategoryCode.value" (update)="onSpendCategorySelected($event)"></app-spend-category-search>
                    </div>
                  </div>

                  @if (cashFlowCategory) {
                    <div class="form-group m-form__group row">
                      <label class="col-form-label col-lg-3 col-sm-12">
                        {{ 'spend-new.form.cashFlowCategory' | transloco }}:
                      </label>
                      <div class="col-lg-4 col-md-4 col-sm-12">
                        {{ cashFlowCategory | uiLabel }}
                      </div>
                    </div>
                  }

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'spend-update.spent' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <input type="text" formControlName="total" class="form-control m-input" placeholder="">
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'spend-update.data' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-date-select formControlName="date"></hx-date-select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'spend-update.payBefore' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-date-select formControlName="payBefore"></hx-date-select>
                    </div>
                  </div>
                </div>

                <div class="m-form__actions m-form__actions--paddingless-sides">
                  <div class="row">
                    <div class="col-12 text-right">
                      <button type="submit" [disabled]="isLoading.save" class="btn btn-success m--margin-right-10">
                        {{ 'btn.save' | transloco }}
                      </button>

                      <button type="button" (click)="cancel()" class="btn btn-secondary m--margin-right-10">
                        {{ 'btn.cancel' | transloco }}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
